// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2iJuM","header":"PatientBlock_header__21zDT","label":"PatientBlock_label__3MeZ0","option":"PatientBlock_option__28yJT"};